import { Outlet } from "@tanstack/react-router";

export function WorkOrderRecordLayout() {
  return <Outlet />;
}
